'use strict';

(function() {
	angular.module('onboarding.common')
		.filter('escapeuri',
			function() {
				return window.encodeURIComponent;
			});
})();
